export default __webpack_public_path__ + "static/media/ico_clients.98a40faa.svg";